import { LOGOUT_REASON_QUERY_KEY, LOGOUT_REASON_SESSION_EXPIRED } from "@/utils/auth";

export interface SessionExpiredNotice {
  visible: ComputedRef<boolean>;
  dismiss: () => void;
}

// Visible quand /login porte ?reason=session-expired (middleware) OU quand le cookie flash
// est posé par heyapi.ts (401 sur route publique, le middleware ne tourne pas).
export function useSessionExpiredNotice(): SessionExpiredNotice {
  const route = useRoute();
  const router = useRouter();
  const cookie = useCookie<string | null>("session-just-expired", { path: "/" });
  const reason = computed(() => {
    const value = route.query[LOGOUT_REASON_QUERY_KEY];
    return Array.isArray(value) ? value[0] : value;
  });
  const flashSurvivingServerConsumption = rememberFlashAcrossHydration(cookie);
  const visible = computed(
    () => reason.value === LOGOUT_REASON_SESSION_EXPIRED || flashSurvivingServerConsumption.value || !!cookie.value
  );
  const dismiss = () => {
    flashSurvivingServerConsumption.value = false;
    cookie.value = null;
    if (reason.value === LOGOUT_REASON_SESSION_EXPIRED) {
      const { [LOGOUT_REASON_QUERY_KEY]: _reason, ...rest } = route.query;
      router.replace({ path: route.path, query: rest, hash: route.hash });
    }
  };
  return { visible, dismiss };
}

// `authenticated.ts` consomme le cookie pendant le SSR : sa suppression arrive au navigateur
// avec le HTML, donc seul le payload garde la lecture faite au rendu.
function rememberFlashAcrossHydration(cookie: Ref<string | null>): Ref<boolean> {
  return useState("session-expired-flash", () => !!cookie.value);
}
